import { createApi } from "@reduxjs/toolkit/query/react";
import type { BaseQueryFn } from "@reduxjs/toolkit/query";
import { REACT_APP_AI_SERVICE_URL } from "utils/environmentVariables";
import { getUserToken } from "utils/helperFunctions";
import type {
  GetRollingCheckInSummaryParams,
  RollingCheckInSummaryResponse,
} from "./types";

const aiServiceBaseQuery: BaseQueryFn<
  { url: string; method?: string },
  unknown,
  { status: number; data: unknown } | { error: string }
> = async ({ url, method = "GET" }) => {
  const token = getUserToken();
  if (!token) return { error: { error: "Unauthenticated" } };
  try {
    const response = await fetch(`${REACT_APP_AI_SERVICE_URL}${url}`, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    if (!response.ok) {
      return { error: { status: response.status, data } };
    }
    return { data };
  } catch (err) {
    return { error: { error: String(err) } };
  }
};

export const teamsAiServiceApi = createApi({
  reducerPath: "teamsAiServiceApi",
  baseQuery: aiServiceBaseQuery,
  endpoints: (builder) => ({
    getRollingCheckInSummary: builder.query<
      RollingCheckInSummaryResponse,
      GetRollingCheckInSummaryParams
    >({
      query: ({ userAccountId, date, refresh, mostRecentCompletedCheckIn }) => {
        const urlParams = new URLSearchParams();
        // AI service requires YYYY-MM-DD; dates from the API may be full ISO strings
        if (date) urlParams.append("date", date.slice(0, 10));
        if (refresh) urlParams.append("refresh", "true");
        if (mostRecentCompletedCheckIn !== undefined) {
          urlParams.append(
            "mostRecentCompletedCheckIn",
            String(mostRecentCompletedCheckIn)
          );
        }
        const qs = urlParams.toString();
        return {
          url: `/v1/chat/rollingCheckInSummary/${userAccountId}${
            qs ? `?${qs}` : ""
          }`,
        };
      },
    }),
  }),
});

export const { useGetRollingCheckInSummaryQuery } = teamsAiServiceApi;
